module.exports = __webpack_public_path__ + "static/nemec-d942a24cb15663f8a52d58818f5eadf4.jpg";